const u = (id, w = 1200) => `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=80`;
const flagged = (id, w = 1200) => `https://images.unsplash.com/flagged/photo-${id}?auto=format&fit=crop&w=${w}&q=80`;

export const ORG = {
  name: "Helpline Health Care Society",
  short: "HECSO",
  established: "18 April 2004",
  address: "HECSO Bhawan, Bylane 3, Rukminigaon, Guwahati, Assam – 781022",
  phone: "+91 84783 81002",
  phone2: "+91 361 246 7890",
  email: "contact@helplinehealthcaresociety.org",
};

export const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "About Us", path: "/about" },
  { label: "Our Work", path: "/our-work" },
  { label: "Programs", path: "/programs" },
  { label: "Projects", path: "/projects" },
  { label: "Events", path: "/events" },
  { label: "Gallery", path: "/gallery" },
  { label: "Reports", path: "/reports" },
  { label: "Get Involved", path: "/get-involved" },
  { label: "Contact", path: "/contact" },
];

export const IMAGES = {
  // Authentic Indian documentary photos (CC-licensed via Openverse/Flickr)
  hero: "https://live.staticflickr.com/65535/51646624722_14ab3a4d27_b.jpg", // woman doctor examining a child at a rural health camp
  healthDesk: "https://live.staticflickr.com/3715/11275220575_2fcbd8e641_b.jpg", // health worker with mothers and children at camp desk
  womenMeeting: "https://live.staticflickr.com/116/288387653_f979cb4223_b.jpg", // village women's group meeting
  womenField: "https://live.staticflickr.com/7535/15464292777_5af9c7d713_b.jpg", // smiling rural women self-help group in a field
  shgWomen: "https://live.staticflickr.com/3372/3653878334_0d8e93f973_b.jpg", // SHG women counting group savings
  womenVocational: "https://live.staticflickr.com/65535/51412637647_b66dc47e87_b.jpg", // vocational learning participant with women's group
  mobileClinic: "https://live.staticflickr.com/8198/8270227748_5f94032703_b.jpg", // treatment inside a mobile health unit
  medicineCounter: "https://live.staticflickr.com/7476/15538235653_e747a18b4e_b.jpg", // women collecting free medicines at a camp counter
  medicalCamp: "https://live.staticflickr.com/8217/8270227802_a9012fefdf_b.jpg", // patients waiting at a rural health camp clinic
  campInauguration: "https://live.staticflickr.com/7552/15835069765_3923334e86_b.jpg", // lamp-lighting inauguration of a free health camp
  gramSabha: "https://live.staticflickr.com/8242/8515648494_a227a60f03_b.jpg", // rural woman addressing a community gathering
  reliefQueue: "https://live.staticflickr.com/7323/10332793533_53ca2062a2_b.jpg", // rural women receiving relief supplies
  eyeCampElderly: "https://live.staticflickr.com/5140/5509037281_ca7fa2e7ca_b.jpg", // elderly patients welcomed at a screening camp
  autoRefra: "https://live.staticflickr.com/65535/51319411789_090d193b26_b.jpg", // optometrist running an autorefractometer test
  schoolEyeTest: "https://live.staticflickr.com/1870/44123344152_c06cac9bd2_b.jpg", // schoolgirl covering one eye during a vision test
  polioDrive: "https://live.staticflickr.com/8357/8291649940_1514251e73_b.jpg", // street immunization drive
  youthGroup: "https://live.staticflickr.com/1318/4732584403_a019a5fbd9_b.jpg", // young men in a group discussion
  nightGathering: "https://live.staticflickr.com/1335/4732592023_f3c457f525_b.jpg", // large crowd at a public awareness event
  assamVillage: "https://live.staticflickr.com/2023/2012833851_cfc6f17978_b.jpg", // post-harvest scene in an Assam village
  elderHands: "https://live.staticflickr.com/8107/8530944828_4fa94c5e8c_b.jpg", // folded hands of an elderly person
  // Unsplash (verified)
  womenCommunity: flagged("1577604981316-298e453a19dd"), // group of Indian women in colourful saris
  youthEducation: u("1692269725911-87697c558be1"), // Indian schoolgirls studying
  childrenSchool: u("1692269725836-fbd72e98883f"), // Indian school children at desks
  ruralCommunity: u("1587538018365-2a1f8b544c08"), // three rural women in saris
  doctorCare: u("1584515933487-779824d29309"), // gloved doctor examining a patient
  heartCare: u("1584982751601-97dcc096659c"), // stethoscope
  diagnostics: u("1602052577122-f73b9710adba"), // laboratory testing
  charityHands: u("1532629345422-7515f3d16bb6"), // hands holding "make a change" note
  children: u("1488521787991-ed7bbaae773c"), // joyful children
  schoolKids: u("1497486751825-1233686d5d80"), // smiling Indian school children
  classroom: u("1509062522246-3755977927d7"), // classroom with teacher
  classroomStudy: u("1427504494785-3a9ca7044f45"), // library study aisle
  schoolKidsIndia: u("1577896851231-70ef18881754"), // Indian classroom session
  teaGarden: u("1596895111956-bf1cf0599ce5"), // river boat at dusk (Brahmaputra valley)
};

export const IMPACT_AREAS = [
  {
    title: "Healthcare",
    description: "Free medical camps, screenings, immunization and awareness programs reaching underserved communities across Assam.",
    image: IMAGES.healthDesk,
    points: ["Free health check-up camps", "Eye screening & cataract referral", "Immunization awareness drives"],
  },
  {
    title: "Education",
    description: "Supporting students and conducting educational awareness initiatives in schools and rural learning centres.",
    image: IMAGES.childrenSchool,
    points: ["School health & hygiene programs", "Educational awareness sessions", "Learning support for rural students"],
  },
  {
    title: "Community Development",
    description: "Programs supporting vulnerable families and rural communities with essential services and welfare initiatives.",
    image: IMAGES.assamVillage,
    points: ["Relief & welfare support", "Rural outreach programs", "Disability support services"],
  },
  {
    title: "Women & Youth Empowerment",
    description: "Skill development, awareness, participation and leadership programs for women and young people.",
    image: IMAGES.womenField,
    points: ["Skill & livelihood training", "Self-help group strengthening", "Youth leadership & volunteering"],
  },
];

export const PROGRAMS = [
  {
    title: "Free Health Check-up Camps",
    slug: "health-camps",
    image: IMAGES.medicalCamp,
    description: "Regular free medical camps in rural and underserved areas offering consultations, basic diagnostics and medicines.",
    details: "Our medical teams, along with volunteer doctors and nurses, organize free health check-up camps across villages and urban settlements. Each camp offers general consultations, blood pressure and blood sugar screening, free medicines and referrals to government health facilities.",
  },
  {
    title: "Eye Screening & Cataract Detection",
    slug: "eye-care",
    image: IMAGES.autoRefra,
    description: "Vision screening, cataract detection and referral support for surgery across schools and communities.",
    details: "In partnership with eye hospitals, HECSO conducts community and school-based eye screening camps. Patients diagnosed with cataract are counselled and referred for free or subsidized surgery, and spectacles are distributed to those in need.",
  },
  {
    title: "HIV/AIDS Awareness",
    slug: "hiv-aids-awareness",
    image: IMAGES.diagnostics,
    description: "Community education on prevention, testing and reducing stigma around HIV/AIDS.",
    details: "Through street plays, community meetings and school sessions, we spread accurate information on HIV/AIDS prevention, testing services and care, working to reduce stigma and discrimination in local communities.",
  },
  {
    title: "Cancer & Diabetes Awareness",
    slug: "cancer-diabetes-awareness",
    image: IMAGES.heartCare,
    description: "Screening and awareness sessions on early detection, lifestyle and preventive care.",
    details: "Our awareness programs educate communities on early warning signs of cancer and diabetes, the importance of screening, and lifestyle choices that reduce risk. Special sessions are held for women's health, including breast and cervical cancer awareness.",
  },
  {
    title: "Anti-Tobacco Campaigns",
    slug: "anti-tobacco",
    image: IMAGES.gramSabha,
    description: "Awareness drives in schools and communities on the harms of tobacco and substance use.",
    details: "HECSO runs anti-tobacco campaigns in schools, colleges and market areas, highlighting the health risks of tobacco and gutkha use. World No Tobacco Day is observed every year with rallies, exhibitions and counselling desks.",
  },
  {
    title: "Women Empowerment",
    slug: "women-empowerment",
    image: IMAGES.womenCommunity,
    description: "Skill training, self-help groups and leadership development for rural women.",
    details: "We support women through tailoring and handicraft training, financial literacy sessions and self-help group formation, helping them build independent incomes and take part in community decision-making.",
  },
  {
    title: "Disability Skill Development",
    slug: "disability-support",
    image: IMAGES.elderHands,
    description: "Vocational training, assistive support and inclusion programs for persons with disabilities.",
    details: "HECSO works with persons with disabilities to provide vocational training, assistive device support and linkage with government welfare schemes, promoting dignity, independence and inclusion.",
  },
  {
    title: "School Health Programs",
    slug: "school-health",
    image: IMAGES.youthEducation,
    description: "Health check-ups, hygiene education and nutrition awareness for school students.",
    details: "Our school health program brings basic health screening, deworming awareness, hygiene education and nutrition counselling to government schools, with follow-up support for children needing care.",
  },
  {
    title: "Youth Development Programs",
    slug: "youth-development",
    image: IMAGES.youthGroup,
    description: "Life-skills, career guidance and volunteer engagement for young people.",
    details: "We engage young people through life-skill workshops, career guidance sessions and volunteer programs, channeling their energy into community service and personal growth.",
  },
  {
    title: "Vaccination & Immunization Awareness",
    slug: "immunization",
    image: IMAGES.polioDrive,
    description: "Promoting immunization coverage through community outreach and counselling.",
    details: "Working alongside frontline health workers, HECSO conducts awareness drives to improve childhood immunization coverage, dispel myths around vaccines and support routine immunization sessions.",
  },
];

export const PROJECTS = [
  {
    title: "School Eye Screening Program",
    image: IMAGES.schoolEyeTest,
    description: "Eye examinations and vision awareness programs conducted for students in schools across Assam.",
    location: "Kamrup & Nalbari, Assam",
    beneficiaries: "2,400+ Students",
    year: "2025–2026",
    status: "Ongoing",
  },
  {
    title: "Rural Health Awareness Program",
    image: IMAGES.ruralCommunity,
    description: "Community health sessions covering hygiene, diabetes, cancer awareness and preventive healthcare.",
    location: "Nalbari & Barpeta Districts",
    beneficiaries: "8,500+ Community Members",
    year: "2024–2026",
    status: "Ongoing",
  },
  {
    title: "Women Skill Development Initiative",
    image: IMAGES.womenVocational,
    description: "Training and awareness programs supporting financial independence and community participation.",
    location: "Kamrup (Metro), Assam",
    beneficiaries: "600+ Women",
    year: "2023–2025",
    status: "Ongoing",
  },
  {
    title: "Community Eye Care Outreach",
    image: IMAGES.eyeCampElderly,
    description: "Mobile eye-care camps conducting screenings, distributing spectacles and referring cataract patients for surgery.",
    location: "Darrang & Morigaon, Assam",
    beneficiaries: "3,100+ People Screened",
    year: "2024–2025",
    status: "Completed",
  },
];

export const STATS = [
  { value: 20, suffix: "+", label: "Years of Service" },
  { value: 50000, suffix: "+", label: "People Reached", display: "50K+" },
  { value: 100, suffix: "+", label: "Community Programs" },
  { value: 30, suffix: "+", label: "Health Camps" },
  { value: 25, suffix: "+", label: "Partner Organizations" },
  { value: 15, suffix: "+", label: "Districts Reached" },
];

export const ACTIVITIES = [
  {
    title: "Free Health Check-up Camp Organized at Rukminigaon",
    date: "24 May 2026",
    category: "Health Camp",
    image: IMAGES.campInauguration,
    description: "Over 320 residents received free consultations, blood sugar and blood pressure screening, and medicines at our community health camp in Guwahati.",
  },
  {
    title: "School Eye Screening Program Completed in Nalbari",
    date: "29 April 2026",
    category: "Eye Care",
    image: IMAGES.youthEducation,
    description: "850 students across 6 schools were screened for vision problems; 74 students received free spectacles and 9 were referred for further care.",
  },
  {
    title: "World Health Day Awareness Campaign",
    date: "7 April 2026",
    category: "Awareness",
    image: IMAGES.polioDrive,
    description: "HECSO volunteers conducted awareness sessions on preventive healthcare and immunization in 12 communities on the occasion of World Health Day.",
  },
  {
    title: "Community Diabetes Awareness Program",
    date: "18 March 2026",
    category: "Awareness",
    image: IMAGES.heartCare,
    description: "A special screening and counselling session on diabetes prevention and management was held for 200+ community members in Barpeta.",
  },
  {
    title: "Women Empowerment Workshop on Financial Literacy",
    date: "8 March 2026",
    category: "Women Empowerment",
    image: IMAGES.shgWomen,
    description: "On International Women's Day, 90 women from self-help groups attended a workshop on savings, banking and small enterprise planning.",
  },
  {
    title: "Anti-Tobacco Awareness Drive in Schools",
    date: "31 May 2026",
    category: "Awareness",
    image: IMAGES.schoolKidsIndia,
    description: "Marking World No Tobacco Day, our team conducted interactive sessions on the dangers of tobacco use for students in 8 schools.",
  },
];

export const GALLERY = [
  { src: IMAGES.medicalCamp, category: "Health Camps", caption: "Free health check-up camp, Guwahati" },
  { src: IMAGES.doctorCare, category: "Health Camps", caption: "Doctor examining a patient at a rural camp" },
  { src: IMAGES.mobileClinic, category: "Health Camps", caption: "Treatment inside our mobile health unit" },
  { src: IMAGES.medicineCounter, category: "Health Camps", caption: "Free medicines distribution at a camp" },
  { src: IMAGES.womenMeeting, category: "Community Programs", caption: "Community meeting at a village centre" },
  { src: IMAGES.reliefQueue, category: "Community Programs", caption: "Relief distribution for vulnerable families" },
  { src: IMAGES.ruralCommunity, category: "Community Programs", caption: "Village community gathering, Nalbari" },
  { src: IMAGES.schoolKids, category: "Education", caption: "Students at a partner government school" },
  { src: IMAGES.schoolKidsIndia, category: "Education", caption: "Health education session in a classroom" },
  { src: IMAGES.youthEducation, category: "Education", caption: "Girls studying at a rural school" },
  { src: IMAGES.healthDesk, category: "Awareness Campaigns", caption: "Health awareness desk for mothers and children" },
  { src: IMAGES.diagnostics, category: "Awareness Campaigns", caption: "Screening and diagnostic support" },
  { src: IMAGES.heartCare, category: "Awareness Campaigns", caption: "Preventive health awareness session" },
  { src: IMAGES.womenField, category: "Women Empowerment", caption: "Members of a women's self-help group" },
  { src: IMAGES.shgWomen, category: "Women Empowerment", caption: "SHG members managing group savings" },
  { src: IMAGES.womenVocational, category: "Women Empowerment", caption: "Vocational training participant with her group" },
  { src: IMAGES.children, category: "Youth Activities", caption: "Children's activity at a community centre" },
  { src: IMAGES.youthGroup, category: "Youth Activities", caption: "Youth leadership workshop" },
  { src: IMAGES.classroomStudy, category: "Youth Activities", caption: "Study support at a learning centre" },
];

export const GALLERY_CATEGORIES = [
  "All",
  "Health Camps",
  "Community Programs",
  "Education",
  "Awareness Campaigns",
  "Women Empowerment",
  "Youth Activities",
];

export const STORIES = [
  {
    name: "Rina Das, 62",
    place: "Nalbari District",
    image: IMAGES.eyeCampElderly,
    title: "Seeing her grandchildren clearly again",
    quote: "For almost three years my world kept getting blurrier. At the HECSO eye camp they told me it was cataract and arranged my surgery. Today I can see my grandchildren's faces clearly. I never thought this would be possible for a family like ours.",
  },
  {
    name: "Majoni Boro, 38",
    place: "Baksa District",
    image: IMAGES.shgWomen,
    title: "From daily wage work to her own tailoring unit",
    quote: "After the tailoring training, I started stitching blouses and school uniforms from home. Now I earn around ₹6,000 a month and two other women from my village work with me. The self-help group taught us how to save and plan.",
  },
  {
    name: "Dipankar Kalita, 14",
    place: "Kamrup (Metro)",
    image: IMAGES.schoolKidsIndia,
    title: "A pair of spectacles that changed his report card",
    quote: "I could not read what teacher wrote on the board, so I stopped trying. At the school screening they checked my eyes and gave me free spectacles. This year I stood third in my class.",
  },
];

export const UPCOMING_EVENTS = [
  {
    title: "Free Mega Health Check-up Camp",
    date: "26 July 2026",
    time: "9:00 AM – 2:00 PM",
    location: "HECSO Community Hall, Rukminigaon, Guwahati",
    image: IMAGES.doctorCare,
    description: "General medicine, eye screening, blood sugar and pressure checks with free medicines. Specialist consultations available.",
  },
  {
    title: "School Eye Screening Drive",
    date: "14 August 2026",
    time: "10:00 AM onwards",
    location: "Govt. Higher Secondary School, Nalbari",
    image: IMAGES.schoolEyeTest,
    description: "Vision screening for 600+ students, with free spectacles for children diagnosed with refractive errors.",
  },
  {
    title: "Anti-Tobacco & Cancer Awareness Rally",
    date: "12 September 2026",
    time: "8:00 AM",
    location: "Barpeta Road Town",
    image: IMAGES.nightGathering,
    description: "Public rally and street play on tobacco harm and cancer prevention, followed by a free counselling desk.",
  },
];

export const PAST_EVENTS = [
  { title: "World No Tobacco Day Awareness Drive", date: "31 May 2026", location: "Guwahati & Nalbari" },
  { title: "World Health Day Campaign", date: "7 April 2026", location: "12 communities across Kamrup" },
  { title: "International Women's Day Workshop", date: "8 March 2026", location: "HECSO Community Hall, Guwahati" },
];

export const REPORTS = [
  { title: "Annual Report 2024–25", type: "Annual Report", year: "2025", pages: "48 pages" },
  { title: "Annual Report 2023–24", type: "Annual Report", year: "2024", pages: "44 pages" },
  { title: "Annual Report 2022–23", type: "Annual Report", year: "2023", pages: "40 pages" },
  { title: "Audited Financial Statement 2023–24", type: "Financial", year: "2024", pages: "22 pages" },
  { title: "Eye Care Program — Activity Report", type: "Program Report", year: "2025", pages: "16 pages" },
  { title: "Women Empowerment Initiative — Impact Summary", type: "Program Report", year: "2024", pages: "12 pages" },
];

export const TIMELINE = [
  { year: "2004", text: "Helpline Health Care Society founded on 18 April 2004 in Guwahati, Assam, by a group of healthcare workers and social volunteers." },
  { year: "2007", text: "First series of free rural health check-up camps organized across Kamrup district." },
  { year: "2011", text: "Community eye-care program launched with screening camps and cataract referral support." },
  { year: "2015", text: "Women empowerment initiative began with skill training and self-help group formation." },
  { year: "2019", text: "Expanded to school health programs and youth development activities across 8 districts." },
  { year: "2023", text: "Disability skill development and livelihood support program introduced." },
  { year: "2026", text: "Crossed 50,000 lives impacted, with 100+ community programs across 15+ districts of Assam." },
];

export const DONATION_IMPACTS = [
  { amount: 500, text: "provides free medicines for 5 patients at a health camp" },
  { amount: 1000, text: "funds eye screening for 10 school children" },
  { amount: 2500, text: "supports a tailoring training kit for one woman" },
  { amount: 5000, text: "helps organize a community health awareness session" },
];
